import { render, staticRenderFns } from "./ListHerramientaPage.vue?vue&type=template&id=0a590b26&scoped=true"
import script from "./ListHerramientaPage.vue?vue&type=script&lang=js"
export * from "./ListHerramientaPage.vue?vue&type=script&lang=js"
import style0 from "./ListHerramientaPage.vue?vue&type=style&index=0&id=0a590b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a590b26",
  null
  
)

export default component.exports